export const getLocationName = (locations, selectedLocationID) => {
  return (
    (locations.find((lData) => lData.loc_id == selectedLocationID) || {})
      .name || "Not Found"
  );
};

export const getDate = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const isShallowEqual = (obj1, obj2) =>
  Object.keys(obj1).length === Object.keys(obj2).length &&
  Object.keys(obj1).every((key) => obj1[key] === obj2[key]);

export const getNext30MinSlot = () => {
  const now = new Date();

  // Add 10 minutes to the current time
  now.setMinutes(now.getMinutes() + 10);

  // Round up to next :00 or :30
  const minutes = now.getMinutes();
  if (minutes > 0 && minutes <= 30) {
    now.setMinutes(30);
  } else {
    now.setMinutes(0);
    now.setHours(now.getHours() + 1);
  }

  now.setSeconds(0);
  now.setMilliseconds(0);

  // Extract hours and minutes
  let hours = now.getHours();
  const minutesStr = now.getMinutes().toString().padStart(2, "0");
  const isPM = hours >= 12;

  // Convert to 12-hour format
  hours = hours % 12 || 12;
  const hoursStr = hours.toString().padStart(2, "0");
  const period = isPM ? "PM" : "AM";

  return `${hoursStr}.${minutesStr}${period}`;
};

export const isToday = (selectedDate) => {
  const today = new Date();
  const inputDate = new Date(selectedDate);

  return (
    today.getFullYear() === inputDate.getFullYear() &&
    today.getMonth() === inputDate.getMonth() &&
    today.getDate() === inputDate.getDate()
  );
}

export const isBeforeNinePM = () => {
  const now = new Date();
  const currentHour = now.getHours();
  return currentHour < 21;
}

export const getCalendarStartDate = () => {
  let startDate = "";
    const today = new Date();
    if (isBeforeNinePM()) {
      startDate = today.toISOString().split("T")[0];
    } else {
      const tomorow = new Date(today);
      tomorow.setDate(today.getDate() + 1);
      startDate = tomorow.toISOString().split("T")[0];
    }
    return startDate;
}


